export default {
  name: "ProgressBar",
  props: {
    progress: Number
  },
  methods: {
    setProgress(progress) {
      this.progress = progress > 1 ? 1 : progress;
    }
  },
  computed: {
    progressTitle() {
      return `${parseInt(this.progress * 100)}%`;
    }
  }
};